<template>
  <div>
    <div class="home-main">
      <img alt="logo" src="../../assets/logo.png">
      <div>
        {{company}}-代理商管理平台
      </div>
    </div>
  </div>
</template>

<script>
import createdMixin from "@/mixin/createMixin";

export default {
  name: "Home",
  mixins: [createdMixin],
  data: () => {
    return {
      data: {
      }
    }
  },
  methods: {
    fetchData() {

    }
  },
  computed: {
    company(){
      return JSON.parse(localStorage.getItem('userinfo')).company
    },
  },
}
</script>

<style lang="scss" scoped>

.home-card {
  position: relative;
  display: block;

  .card {
    position: absolute;
    top: 40%;
    left: 50%;

    div:nth-child(2) {
      text-align: center;
      color: #fb6604;
      font-size: 20px;
    }
  }
}

.home-main {
  text-align: center;
  margin-bottom: 10%;

  img {
    width: 100px;
  }
}
</style>
